<template>
  <v-container>
    <v-row justify="center">
      <v-btn
        text
        outlined
        color="dark"
        class="ma-2"
        @click="dialog=true">
        授業に応募する
      </v-btn>
    </v-row>
    <v-dialog
      v-model="dialog"
      persistent
      max-width="600px">
      <v-card>
        <v-card-title>
          <span class="headline">
            応募内容
          </span>
        </v-card-title>
        <div v-if="teaching">
          <v-card-text>
            <v-icon>warning</v-icon><br>
            <span style="color:#ff0000;">{{ student.fullName() }}さんはすでに授業予定があります。</span><br>
            <span style="color:#ff0000;">追加で授業応募を行う場合のみ応募してください。</span><br>
            <span style="color:#ff0000;">{{ student.fullName() }}さんの予定は「授業一覧」から確認できます。</span>
          </v-card-text>
        </div>
        <div v-if="hasApplied">
          <v-card-text>
            <v-icon>warning</v-icon><br>
            <span style="color:#ff0000;">{{ student.fullName() }}さんはすでに授業応募済です。</span><br>
            <span style="color:#ff0000;">応募は未承認であるため、授業応募追加の場合のみ応募してください。</span><br>
            <span style="color:#ff0000;">応募の内容は「あなたの応募状況」から確認できます。</span>
          </v-card-text>
        </div>
        <div v-if="isApplied">
          <v-card-text>
            <v-icon>warning</v-icon><br>
            <span style="color:#ff0000;">あなたに{{ student.fullName() }}さんへの授業依頼があります。</span><br>
            <span style="color:#ff0000;">授業依頼は未承認であるため、授業依頼を確認の上、応募してください。</span>
          </v-card-text>
        </div>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col>
                <h3>{{ student.fullName() + '　さん' }}</h3>
              </v-col>
                <ScheduleSelector
                  v-model="schedule"
                  :enableToAdd="false"
                />
              <v-col md="6">
                <v-select
                  v-model="wage"
                  :items="wageRange"
                  label="1回あたり報酬(円)"
                  v-validate="'required'"
                  data-vv-name="wage"
                  data-vv-as="報酬金額"
                  required
                  :error-messages="errors.collect('wage')"
                ></v-select>
              </v-col>
              <v-col md="12">
                <v-textarea
                  v-model="note"
                  label="コメント"
                  outlined
                >
                </v-textarea>
              </v-col>
            </v-row>
          </v-container>
        </v-card-text>
        <v-card-text
          class="font-weight-bold red--text"
          v-show="errorMessage">
          {{ this.errorMessage }}
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            @click="sendOffer">
            送信する
          </v-btn>
          <v-btn
            color="blue darken-1"
            text
            @click="dialog=false">
            閉じる
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="afterSendingDialog"
      persistent
      max-width="370">
      <v-card>
        <v-card-title
          class="headline">
          応募が完了しました。
        </v-card-title>
        <v-card-text>
          <span class="text--primary">
            応募が承認されると、授業予定に反映されます。
          </span>
        </v-card-text>
        <v-row
          justify="center">
          <v-card-actions>
            <v-btn
              outlined
              color="dark"
              @click="afterSending()">
              閉じる
            </v-btn>
          </v-card-actions>
        </v-row>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import ScheduleSelector from '@/components/molecules/ScheduleSelector.vue'
import { LessonOfferRepository } from '@/repository/LessonOfferRepository.js'
import { firestore } from '@/repository/client/firestore.js'

export default {
  name: 'LessonOfferForm',
  components:{
    ScheduleSelector: ScheduleSelector,
  },
  props:{
    student: Object,
    offers: Object,
  },
  $_veeValidate: {
    validator: 'new',
  },
  data() {
    return {
      afterSendingDialog: false,
      offeredStudentIds: [],
      inOfferStudentIds: [],
      teachingStudentIds:[],
      teacher: this.$store.getters.teacher,
      offerRepo: null,
      schedule: {},
      wage: null,
      note: "",
      dialog: false,
      errorMessage: null
    }
  },
  methods: {
    async sendOffer() {
      const result = await this.$validator.validateAll()
      if (result) {
        try {
          const lesson = {
            teacherId: this.teacher.uuid,
            parentId: this.student.parentId,
            studentId: this.student.id,
            schedule: this.schedule,
            wage: this.wage,
            note: this.note ? this.note : 'なし',
            Ids: []
          }
          const lessonOffer = await this.offerRepo.put(
            lesson,
            this.teacher.uuid,
            this.student.parentId,
          )
          this.offeredStudentIds.push(this.student.id)
          this.dialog = false
          this.afterSendingDialog = true
        } catch(e) {
          this.errorMessage = "指導日時は必須項目です"
        }
      }
    },
    afterSending() {
      this.afterSendingDialog = false
      this.$emit("afterSending")
    }
  },
  computed: {
    wageRange() {
      var range = new Array()
      for (let i = 10; i <= 500; i++) {
        range.push(i * 100)
      }
      return range
    },
    hasApplied() {
      return this.offers.inOffers().getStudentIds().includes(this.student.id)
    },
    isApplied() {
      return this.inOfferStudentIds.includes(this.student.id)
    },
    teaching() {
      return this.teachingStudentIds.includes(this.student.id)
    },
  },
  created: async function() {
    this.offerRepo = new LessonOfferRepository(firestore)
    const offersFromParent = await this.offerRepo.listOfInOffer(this.teacher.uuid)
    this.teachingStudentIds = this.teacher.lessons.getStudentIds()
    this.inOfferStudentIds = offersFromParent.getStudentIds()
  },

}
</script>